// extracted by mini-css-extract-plugin
export var standaloneTable = "_k4-0";
export var standaloneTableWithBodyFill = "_k4-1";
export var withExtraHeader = "_k4-2";